// import React from "react";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// const NerveHub = () => {
//   const history = useHistory();
//   const clickHandler = () => {
//     history.push(
//       `/?layout=full&appinitials=DigitalUM&appname=Digital20%UM20%Application&theme=light&platform=nervehub`
//     );
//   };

//   return (
//     <a href="" onClick={clickHandler}>
//       Click here to Go to Digital UM
//     </a>
//   );
// };

// export default NerveHub;
import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import UserContext from "../components/Common/UserContext";

const NerveHub = () => {
  const history = useHistory();
  const { setUserRole } = useContext(UserContext);

  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
    setUserRole("");
  }, []);

  const handleClick = (event) => {
    event.preventDefault();
    history.push(`/TokenFetching`);
  };

  return (
    <a href="#" onClick={() => {}}>
      Click here to Go to Digital UM
    </a>
  );
};

export default NerveHub;
